import React from 'react'
import { Modal } from 'react-responsive-modal';
import 'react-responsive-modal/styles.css';
import {
    FacebookIcon,
    TelegramIcon,
    WhatsappIcon,
} from "react-share";
import {
    FacebookShareButton,
    TelegramShareButton,
    WhatsappShareButton,
} from "react-share";
import "./shareModalStyle.css"

const ShareModal = ({ openShareModal, closeFunc, shareBoxTitle, title, shareUrl }) => {

    return (
        <Modal open={openShareModal} onClose={closeFunc} center>

            <h4 style={{ marginTop: '25px' }}>{shareBoxTitle}</h4>

            <div style={{ textAlign: 'center' }}>

                <div className="Demo__some-network">
                    <FacebookShareButton
                        url={shareUrl}
                        quote={title}
                        className="Demo__some-network__share-button">
                        <FacebookIcon size={32} round />
                    </FacebookShareButton>
                </div>

                <div className="Demo__some-network">
                    <TelegramShareButton
                        url={shareUrl}
                        title={title}
                        className="Demo__some-network__share-button"
                    >
                        <TelegramIcon size={32} round />
                    </TelegramShareButton>

                    <div className="Demo__some-network__share-count">&nbsp;</div>
                </div>

                <div className="Demo__some-network">
                    <WhatsappShareButton
                        url={shareUrl}
                        title={title}
                        separator=":: "
                        className="Demo__some-network__share-button"
                    >
                        <WhatsappIcon size={32} round />
                    </WhatsappShareButton>

                    <div className="Demo__some-network__share-count">&nbsp;</div>
                </div>

            </div>

        </Modal>
    )
}

export default ShareModal
